import React from "react"
import { Navbar, Footer, HeroSelector } from "./Components"
import { logo_icon } from "./res/imgs/logos"
import { Switch, Route, useLocation } from "react-router-dom"
import { Home, Cashmere, Products, Contacts } from "./Pages"
import { pathnames } from "./config"
import styled from "styled-components"

const Wrapper = styled.div`
    position: relative;
    width: 100vw;
    height: ${(props) => (props.isContact ? "" : "100vh")};
`

function Landing() {
    const location = useLocation()

    return (
        <>
            <Wrapper isContact={location.pathname === pathnames[3]}>
                <Navbar logo={logo_icon} />
                <HeroSelector />
            </Wrapper>
            <Switch>
                <Route path={pathnames[0]} exact component={Home} />
                <Route path={pathnames[1]} exact component={Cashmere} />
                <Route path={pathnames[2]} exact component={Products} />
                <Route path={pathnames[3]} exact component={Contacts} />
            </Switch>
            <Footer />
        </>
    )
}
export default Landing
